export enum ProfileClass {
    FundoInvestimento = 'FIN - Fundos de Investimentos',
    FundoCota = 'FAC - Fundos em Cotas'
}
